<div *ngIf="!userValidation$" class="home_container full-height">
  <div class="mat-card mat-elevation-z3 login-wrapper">
    <div class="landing_headline">
      <img class="empamos-logo" src="../../../assets/files/empamos_logo.png" alt="image">
      <!--h1><span style="font-weight:normal;color:#333;"></span>EMPAMOS<span style="font-weight:normal;color:#333;"><br/>Toolbox</span>
      </h1>
      <h2>Spielerisch Motivation erzeugen</h2-->
    </div>
    <div class="landing_text">
      <p>Herzlich Willkommen zur EMPAMOS-WebApp! Hier können Sie auf die Ergebnisse des Forschungsprojekts
        <a href="https://www.empamos.de/de">EMPAMOS</a> zugreifen, dass die Technische Hochschule Nürnberg durchführt.
      <p>Bitte beachten Sie, dass nur Teilnehmer*innen unserer <a
        href="https://www.empamos.de/de/angebot/">Weiterbildung</a> diese WebApp nutzen können, um damit Motivation spielerisch zu gestalten.</p>
      <p>Falls Sie selbst Interesse an den Inhalten oder unserer Weiterbildung haben, nehmen Sie gerne Kontakt mit uns auf: <a
        href="https://www.empamos.de/de/impressum/">Impressum</a></p>
      <ng-container #login>
        <em-login class="login-button"></em-login>
      </ng-container>
    </div>
  </div>
</div>
<ng-container *ngIf="userValidation$ | async as userValidation">
  <div class="toolbarspacer">
    <em-dashboard *ngIf="userValidation !== undefined" [timestamp]="this.timestamp"></em-dashboard>
  </div>
</ng-container>
